import { PausedPaymentsActionTypes } from "models/actionTypes/pausedPaymentsActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const pausedPaymentsUpdated = (
  pausedPayments: WintSuperkollAPIModel.PausedPayments
): PausedPaymentsActionTypes => {
  return {
    type: ReduxConstants.PausedPaymentsActions.PAUSED_PAYMENTS_REPORT_UPDATED,
    payload: pausedPayments,
  };
};

export const pausedPaymentsCompleted = (id: number): PausedPaymentsActionTypes => {
  return {
    type: ReduxConstants.PausedPaymentsActions.PAUSED_PAYMENTS_REPORT_COMPLETED,
    payload: id,
  };
};
